import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

import { ModalHOC } from '../../hocs/with_modal'
import NoTranslate from '../../hocs/NoTranslate'

import './video_modal.css'
import ScanAvatar from '../scan_avatar'

const AvatarModal = (props) => {
  console.log(props.isModalOpen)
  return (
    <div
      className={`avatar-modal-container ${props.className || ''}`}
      onClick={props.shouldOpen ? props.openModal : null}
      style={props.style}
    >
      {props.children}
      {props.shouldOpen && (
        <Modal isOpen={props.isModalOpen} toggle={props.closeModal}>
          <ModalHeader
            toggle={props.closeModal}
            style={{ borderBottom: 'none' }}
          >
            <NoTranslate>{props.header}</NoTranslate>
          </ModalHeader>
          <ModalBody>
            <ScanAvatar {...props} />
          </ModalBody>
        </Modal>
      )}
    </div>
  )
}

AvatarModal.propTypes = {
  children: PropTypes.node,
  shouldOpen: PropTypes.bool.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isModalOpen: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default ModalHOC(AvatarModal)
